<template>
  <footer
    class="flex p-4 w-full justify-center"
    :class="[isEncuentro2026 ? 'bg-black' : isEncuentro2024 ? 'bg-grisEncuentro': 'bg-azulOscuro']"
  >
    <div
      class="
        inner-footer
        flex-col-nowrap
        text-center
        w-full
        items-center
        p-4
        lg:max-w-screen-lg
      "
    >
      <div 
        class="max-w-full text-3xl flex flex-col md:flex-row-nowrap md:justify-around
       text-center font-normal font-subheading p-4  "
      >
        <span 
          :class="[isEncuentro2024 ?'text-naranjaamarillo':'text-amarillo']"
        >
          Encuentro Latinoamericano
        </span>
        <span
          class=" px-3"
          :class="[isEncuentro2024 ? 'text-azulOscuro': 'text-gray-300']"
        >
          de Recreación Comunitaria.
        </span>
        <span class="text-red-600"> Abriendo el Juego en Santa Fe </span>
      </div>
    </div>
  </footer>
</template>

<script>

import isPage from '@/mixins/isPageMixin.js';

export default {
  components: {},
  mixins: [isPage],
  data() {
    return {};
  },
};
</script>

<style scoped>
@media screen and (max-width: 300px) {
  .inner-footer {
    padding: 3vw 2vw;
  }

  .inner-footer span {    
    white-space: normal;
    font-size: 5vw;
    padding: 0;
  }

  footer {
    padding: 0;
  }
}

@media screen and (min-width: 768px) {
  .inner-footer div {
    font-size: 2vw;
  }
}

@media screen and (min-width: 1024px) {
  .inner-footer div {
    font-size: 2rem;
  }
}
</style>


